import { deepMerge } from './';
/**
 * Map sources(s) to target recursively, creating a clone that is not reference equal to the source. Object and
 * array types are recreated, other types are copied.
 *
 * @param {object} target The target object
 * @param {object} sources The source(s)
 * @returns {object} The copied opject
 */
export default function deepAssign(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    return deepMerge(target, sources);
}
//# sourceMappingURL=deep-assign.js.map